import http from '@/services/api';
import { IApi } from '@/types/auth';

export const SignIn = async (values: IApi.SignIn) => {
  return await http.post(`/admin/login`, {
    ...values,
  });
};